import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

const url = `${PREFIX_URL}/projects/:projectId/saveDriveFolder`;

type SelectGoogleDriveFolderResponse = { status: boolean };

export type SelectGoogleDriveFolderDTO = {
  projectId: string | number;
  folderId: string | number;
  folderName: string;
};

export const selectGoogleDriveFolder = ({
  projectId,
  folderId,
  folderName,
}: SelectGoogleDriveFolderDTO): Promise<SelectGoogleDriveFolderResponse> => {
  const URL = generateRoutePath(url, { projectId });
  return axios.post(URL, { folderId, folderName }, { showError: false });
};

type UseSelectGoogleDriveFolderOptions = {
  config?: MutationConfig<typeof selectGoogleDriveFolder>;
};

export const useSelectGoogleDriveFolder = ({ config }: UseSelectGoogleDriveFolderOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (props: SelectGoogleDriveFolderDTO) => selectGoogleDriveFolder(props),
  });
};
